import { useEffect } from 'react'

export const useBrowserTabTitle = (title: string) => {
  useEffect(() => {
    document.title = title
  }, [title])
}
